(() => {

document.addEventListener("DOMContentLoaded", ()=>{
    const initializedSlots = new WeakSet();
    function setSlotFailed(slot) {
        slot.classList.add("restaurant-google-photo--failed");
        slot.querySelectorAll(".restaurant-card-media__image, .restaurant-google-photo__image, .restaurant-card-media__attribution, .restaurant-google-photo__attribution, .restaurant-google-maps-logo").forEach((element)=>element.remove());
    }
    function bindSlot(slot) {
        if (initializedSlots.has(slot)) return;
        initializedSlots.add(slot);
        const image = slot.querySelector(".restaurant-card-media__image, .restaurant-google-photo__image");
        if (!image) {
            setSlotFailed(slot);
            return;
        }
        image.addEventListener("error", ()=>setSlotFailed(slot), {
            once: true
        });
        if (image.complete && image.naturalWidth === 0) setSlotFailed(slot);
    }
    function loadRestaurantGooglePhotos(root = document) {
        root.querySelectorAll("[data-restaurant-google-photo]").forEach(bindSlot);
    }
    window.BMTG = window.BMTG || {};
    window.BMTG.loadRestaurantGooglePhotos = loadRestaurantGooglePhotos;
    loadRestaurantGooglePhotos();
});


// Website closure notice on a restaurant card (data-closure-start, -end and
// -status, from OpenTouristInfo via EliSync): while the closure runs, the card
// is closed whatever its weekly hours say. Dates are site-local YYYY-MM-DD.
const $9c39b072f760b268$var$isoDatePattern = /^\d{4}-\d{2}-\d{2}$/;
function $9c39b072f760b268$export$9125ba1101da0ebf(dataset, today) {
    const start = dataset && dataset.closureStart || "";
    const end = dataset && dataset.closureEnd || "";
    if (!$9c39b072f760b268$var$isoDatePattern.test(start) || !$9c39b072f760b268$var$isoDatePattern.test(end) || !$9c39b072f760b268$var$isoDatePattern.test(today || "") || today < start || today > end) return null;
    return String(dataset.closureStatus || "").trim();
}


document.addEventListener("DOMContentLoaded", ()=>{
    const filterBar = document.querySelector(".archive-restaurants-filters");
    const toggle = document.getElementById("open-now-filter");
    const results = document.querySelector("[data-restaurant-archive-results]");
    const grid = document.querySelector("[data-restaurant-archive-grid]");
    const pagination = document.querySelector("[data-restaurant-archive-pagination]");
    const regionSelect = document.getElementById("restaurant-filter-region");
    const canonicalSelects = Array.from(document.querySelectorAll(".archive-canonical-filter"));
    const resetButton = document.getElementById("restaurant-reset-filters");
    const emptyState = document.getElementById("open-now-filter-empty");
    const ajaxConfig = window.bmtgRestaurantsArchive || {};
    const selectedCanonicalFilters = {};
    const filterQueryKeys = [
        "venue",
        "cuisine",
        "service",
        "region",
        "open_now"
    ];
    let selectedRegion = "";
    let cards = [];
    let activeRequest = null;
    if (!filterBar) return;
    const siteTimeZone = filterBar.getAttribute("data-restaurant-time-zone") || "Europe/Berlin";
    const dayNameToIndex = {
        Mon: 0,
        Tue: 1,
        Wed: 2,
        Thu: 3,
        Fri: 4,
        Sat: 5,
        Sun: 6
    };
    const dayNames = [
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
        "Samstag",
        "Sonntag"
    ];
    const openIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="16" height="16"><path fill="currentColor" d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/></svg>';
    const closedIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="12" height="12"><path fill="currentColor" d="M393.4 41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 256l169.4 169.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 301.3 54.6 470.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 9.4 86.6C-3.1 74.1-3.1 53.9 9.4 41.4s32.8-12.5 45.3 0L224 210.7 393.4 41.4z"/></svg>';
    function setSelectValueIfAvailable(select, value) {
        if (!select || value === "") {
            if (select) select.value = "";
            return;
        }
        const hasOption = Array.from(select.options).some((option)=>option.value === value);
        select.value = hasOption ? value : "";
    }
    function syncSelectedFiltersFromControls() {
        canonicalSelects.forEach((select)=>{
            const group = select.dataset.filterGroup || "";
            if (group) selectedCanonicalFilters[group] = select.value || "";
        });
        selectedRegion = regionSelect ? regionSelect.value || "" : "";
    }
    function applyUrlFiltersToControls() {
        const params = new URLSearchParams(window.location.search);
        canonicalSelects.forEach((select)=>{
            const group = select.dataset.filterGroup || "";
            if (group) setSelectValueIfAvailable(select, params.get(group) || "");
        });
        setSelectValueIfAvailable(regionSelect, params.get("region") || "");
        if (toggle) toggle.checked = params.get("open_now") === "1";
        syncSelectedFiltersFromControls();
    }
    applyUrlFiltersToControls();
    function getCards() {
        return Array.from(document.querySelectorAll(".archive-restaurants-main .hometopchild"));
    }
    function getRestaurantRegions(card) {
        if (!card.dataset || !card.dataset.restaurantRegions) return [];
        return card.dataset.restaurantRegions.split(",").map((slug)=>slug.trim()).filter((slug)=>slug.length > 0);
    }
    function getRestaurantFilterValues(card, group) {
        const value = card.getAttribute(`data-restaurant-${group}-filters`) || "";
        return value.split(",").map((code)=>code.trim()).filter((code)=>code.length > 0);
    }
    function hasCanonicalFilterSelection() {
        return Object.keys(selectedCanonicalFilters).some((group)=>selectedCanonicalFilters[group] !== "");
    }
    function hasActiveFilters() {
        return toggle && toggle.checked || selectedRegion !== "" || hasCanonicalFilterSelection();
    }
    function matchesCanonicalFilters(card) {
        return Object.keys(selectedCanonicalFilters).every((group)=>{
            const selectedFilter = selectedCanonicalFilters[group] || "";
            return selectedFilter === "" || getRestaurantFilterValues(card, group).indexOf(selectedFilter) !== -1;
        });
    }
    function parseTimeToSeconds(value) {
        const match = String(value || "").match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
        if (!match) return null;
        const hours = Math.min(23, Math.max(0, parseInt(match[1], 10) || 0));
        const minutes = Math.min(59, Math.max(0, parseInt(match[2], 10) || 0));
        const seconds = Math.min(59, Math.max(0, parseInt(match[3] || "0", 10) || 0));
        return hours * 3600 + minutes * 60 + seconds;
    }
    function formatTime(value) {
        const parts = String(value || "").split(":");
        return parts.length >= 2 ? `${parts[0]}:${parts[1]}` : "";
    }
    function getZonedNow() {
        const formatterOptions = {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            weekday: "short",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false,
            timeZone: siteTimeZone
        };
        try {
            const parts = new Intl.DateTimeFormat("en-US", formatterOptions).formatToParts(new Date());
            const values = {};
            parts.forEach((part)=>{
                if (part.type !== "literal") values[part.type] = part.value;
            });
            let hour = parseInt(values.hour, 10);
            if (hour === 24) hour = 0;
            return {
                date: `${values.year}-${values.month}-${values.day}`,
                day: Object.prototype.hasOwnProperty.call(dayNameToIndex, values.weekday) ? dayNameToIndex[values.weekday] : null,
                seconds: hour * 3600 + (parseInt(values.minute, 10) || 0) * 60 + (parseInt(values.second, 10) || 0)
            };
        } catch (error) {
            const now = new Date();
            const day = now.getDay() === 0 ? 6 : now.getDay() - 1;
            const pad = (value)=>String(value).padStart(2, "0");
            return {
                date: `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`,
                day: day,
                seconds: now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds()
            };
        }
    }
    function getRestaurantOpeningHours(card) {
        if (!card.dataset || !card.dataset.openingHours) return [];
        try {
            const hours = JSON.parse(card.dataset.openingHours);
            return Array.isArray(hours) ? hours : [];
        } catch (error) {
            return [];
        }
    }
    function slotMatchesCurrentTime(slot, now) {
        const from = parseTimeToSeconds(slot.from);
        const to = parseTimeToSeconds(slot.to);
        const days = Array.isArray(slot.days) ? slot.days : [];
        if (from === null || to === null || !days.length || now.day === null) return false;
        return days.some((day)=>{
            const dayIndex = parseInt(day, 10);
            if (from <= to) return dayIndex === now.day && now.seconds >= from && now.seconds <= to;
            return dayIndex === now.day && now.seconds >= from || (dayIndex + 1) % 7 === now.day && now.seconds <= to;
        });
    }
    function findCurrentSlot(hours, now) {
        for(let index = 0; index < hours.length; index += 1){
            if (slotMatchesCurrentTime(hours[index], now)) return hours[index];
        }
        return null;
    }
    function findNextOpening(hours, now) {
        let nextOpening = null;
        hours.forEach((slot)=>{
            const from = parseTimeToSeconds(slot.from);
            const days = Array.isArray(slot.days) ? slot.days : [];
            if (from === null || now.day === null) return;
            days.forEach((day)=>{
                const dayIndex = parseInt(day, 10);
                let daysUntil = (dayIndex - now.day + 7) % 7;
                if (daysUntil === 0 && from <= now.seconds) daysUntil = 7;
                const sortValue = daysUntil * 86400 + from;
                if (!nextOpening || sortValue < nextOpening.sortValue) nextOpening = {
                    day: dayIndex,
                    daysUntil: daysUntil,
                    time: slot.from,
                    sortValue: sortValue
                };
            });
        });
        return nextOpening;
    }
    function getOpeningStatusFromHours(hours, now) {
        if (!hours.length) return null;
        const currentSlot = findCurrentSlot(hours, now);
        if (currentSlot) return {
            status: "open",
            icon: openIcon,
            message: "Ge\xf6ffnet",
            timeInfo: `schlie\xdft um ${formatTime(currentSlot.to)} Uhr`
        };
        const nextOpening = findNextOpening(hours, now);
        if (!nextOpening) return null;
        let timeInfo = `\xf6ffnet um ${formatTime(nextOpening.time)} Uhr`;
        if (nextOpening.daysUntil === 1) timeInfo = `\xf6ffnet morgen um ${formatTime(nextOpening.time)} Uhr`;
        else if (nextOpening.daysUntil > 1 && nextOpening.daysUntil < 7) timeInfo = `\xf6ffnet ${dayNames[nextOpening.day]} um ${formatTime(nextOpening.time)} Uhr`;
        return {
            status: "closed",
            icon: closedIcon,
            message: "Geschlossen",
            timeInfo: timeInfo
        };
    }
    function updateCardOpeningStatus(card, statusInfo) {
        if (!card.dataset) return;
        if (!statusInfo) {
            card.dataset.openingStatus = "unknown";
            card.classList.remove("hometopchild--open", "hometopchild--closed", "hometopchild--unknown");
            card.classList.add("hometopchild--unknown");
            return;
        }
        card.dataset.openingStatus = statusInfo.status;
        card.classList.remove("hometopchild--open", "hometopchild--closed", "hometopchild--unknown");
        card.classList.add(`hometopchild--${statusInfo.status}`);
        const statusElement = card.querySelector(".opening-status");
        if (!statusElement) return;
        statusElement.classList.toggle("opening-status--open", statusInfo.status === "open");
        statusElement.classList.toggle("opening-status--closed", statusInfo.status === "closed");
        const icon = statusElement.querySelector(".opening-status__icon--status");
        const message = statusElement.querySelector(".opening-status__message");
        const time = statusElement.querySelector(".opening-status__time");
        if (icon) icon.innerHTML = statusInfo.icon;
        if (message) message.textContent = statusInfo.message;
        if (time) time.textContent = statusInfo.timeInfo;
    }
    function refreshOpeningStatuses() {
        const now = getZonedNow();
        cards = getCards();
        cards.forEach((card)=>{
            const closureStatus = (0, $9c39b072f760b268$export$9125ba1101da0ebf)(card.dataset, now.date);
            updateCardOpeningStatus(card, closureStatus !== null ? {
                status: "closed",
                icon: closedIcon,
                message: "Geschlossen",
                timeInfo: closureStatus
            } : getOpeningStatusFromHours(getRestaurantOpeningHours(card), now));
        });
    }
    function applyFilters() {
        cards = getCards();
        cards.forEach((card)=>{
            if (!card.dataset || !card.dataset.openingStatus) card.dataset.openingStatus = "unknown";
            card.classList.remove("is-hidden-by-filter");
        });
        if (emptyState) emptyState.hidden = !(cards.length === 0 && hasActiveFilters());
        if (resetButton) resetButton.disabled = !hasActiveFilters();
    }
    function getArchiveBaseUrl() {
        return ajaxConfig.archiveUrl || `${window.location.origin}/restaurants/`;
    }
    function getUrlWithSelectedFilters(url) {
        const nextUrl = new URL(url, window.location.href);
        filterQueryKeys.forEach((key)=>{
            nextUrl.searchParams.delete(key);
        });
        Object.keys(selectedCanonicalFilters).forEach((group)=>{
            const value = selectedCanonicalFilters[group] || "";
            if (value !== "") nextUrl.searchParams.set(group, value);
        });
        if (selectedRegion !== "") nextUrl.searchParams.set("region", selectedRegion);
        if (toggle && toggle.checked) nextUrl.searchParams.set("open_now", "1");
        return nextUrl.toString();
    }
    function appendSelectedFilters(formData) {
        Object.keys(selectedCanonicalFilters).forEach((group)=>{
            formData.append(`filters[${group}]`, selectedCanonicalFilters[group] || "");
        });
        formData.append("filters[region]", selectedRegion || "");
        formData.append("filters[open_now]", toggle && toggle.checked ? "1" : "");
    }
    function getPageFromUrl(url) {
        try {
            const parsedUrl = new URL(url, window.location.href);
            const paged = parsedUrl.searchParams.get("paged");
            const pathMatch = parsedUrl.pathname.match(/\/page\/(\d+)\/?$/);
            if (paged) return Math.max(1, parseInt(paged, 10) || 1);
            if (pathMatch) return Math.max(1, parseInt(pathMatch[1], 10) || 1);
        } catch (error) {
            return 1;
        }
        return 1;
    }
    function setLoadingState(isLoading) {
        if (!results) return;
        results.setAttribute("aria-busy", isLoading ? "true" : "false");
        results.classList.toggle("is-loading", isLoading);
    }
    function showAjaxError() {
        if (!results || !ajaxConfig.errorText) return;
        let error = results.querySelector(".archive-restaurants-ajax-error");
        if (!error) {
            error = document.createElement("p");
            error.className = "archive-restaurants-ajax-error";
            results.prepend(error);
        }
        error.textContent = ajaxConfig.errorText;
    }
    function clearAjaxError() {
        const error = results ? results.querySelector(".archive-restaurants-ajax-error") : null;
        if (error) error.remove();
    }
    function updateBrowserUrl(url, historyMode = "push") {
        if (!window.history || !window.history.pushState) return;
        const nextUrl = getUrlWithSelectedFilters(url);
        const state = {
            restaurantArchivePage: getPageFromUrl(nextUrl)
        };
        if (historyMode === "replace" && window.history.replaceState) window.history.replaceState(state, "", nextUrl);
        else window.history.pushState(state, "", nextUrl);
    }
    function scrollToResults() {
        if (!filterBar || !window.matchMedia("(prefers-reduced-motion: no-preference)").matches) return;
        filterBar.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    }
    async function loadArchivePage(url, historyMode = "push") {
        if (!grid || !pagination || !ajaxConfig.ajaxUrl || !ajaxConfig.nonce) {
            window.location.href = url;
            return;
        }
        if (activeRequest) activeRequest.abort();
        activeRequest = new AbortController();
        const formData = new FormData();
        formData.append("action", ajaxConfig.action || "bmtg_restaurant_archive_page");
        formData.append("nonce", ajaxConfig.nonce);
        formData.append("page", String(getPageFromUrl(url)));
        appendSelectedFilters(formData);
        clearAjaxError();
        setLoadingState(true);
        try {
            const response = await fetch(ajaxConfig.ajaxUrl, {
                method: "POST",
                credentials: "same-origin",
                body: formData,
                signal: activeRequest.signal
            });
            const payload = await response.json();
            if (!response.ok || !payload || !payload.success || !payload.data) throw new Error("Restaurant archive request failed.");
            grid.innerHTML = payload.data.posts || "";
            pagination.innerHTML = payload.data.pagination || "";
            refreshOpeningStatuses();
            applyFilters();
            if (window.BMTG && typeof window.BMTG.loadRestaurantGooglePhotos === "function") window.BMTG.loadRestaurantGooglePhotos(grid);
            if (historyMode) {
                updateBrowserUrl(url, historyMode);
                scrollToResults();
            }
        } catch (error) {
            if (error.name !== "AbortError") showAjaxError();
        } finally{
            setLoadingState(false);
            activeRequest = null;
        }
    }
    if (pagination) pagination.addEventListener("click", (event)=>{
        const link = event.target.closest("a");
        if (!link || !pagination.contains(link)) return;
        const url = link.getAttribute("href");
        if (!url) return;
        event.preventDefault();
        loadArchivePage(url);
    });
    window.addEventListener("popstate", ()=>{
        applyUrlFiltersToControls();
        loadArchivePage(window.location.href, false);
    });
    refreshOpeningStatuses();
    if (regionSelect) regionSelect.addEventListener("change", ()=>{
        syncSelectedFiltersFromControls();
        applyFilters();
        loadArchivePage(getArchiveBaseUrl(), "replace");
    });
    canonicalSelects.forEach((select)=>{
        select.addEventListener("change", ()=>{
            const group = select.dataset.filterGroup || "";
            if (group) selectedCanonicalFilters[group] = select.value || "";
            syncSelectedFiltersFromControls();
            applyFilters();
            loadArchivePage(getArchiveBaseUrl(), "replace");
        });
    });
    if (toggle) toggle.addEventListener("change", ()=>{
        syncSelectedFiltersFromControls();
        applyFilters();
        loadArchivePage(getArchiveBaseUrl(), "replace");
    });
    if (resetButton) resetButton.addEventListener("click", ()=>{
        if (toggle) toggle.checked = false;
        canonicalSelects.forEach((select)=>{
            select.value = "";
            const group = select.dataset.filterGroup || "";
            if (group) selectedCanonicalFilters[group] = "";
        });
        if (regionSelect) regionSelect.value = "";
        selectedRegion = "";
        syncSelectedFiltersFromControls();
        applyFilters();
        loadArchivePage(getArchiveBaseUrl(), "replace");
    });
    applyFilters();
    window.setInterval(()=>{
        refreshOpeningStatuses();
        applyFilters();
    }, 60000);
});



})();
//# sourceMappingURL=bundle-restaurants.js.map
